"use strict";
'use client';

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverVariants = exports.PopoverTrigger = exports.PopoverContent = exports.PopoverAnchor = exports.Popover = void 0;
var React = _interopRequireWildcard(require("react"));
var PopoverPrimitive = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _cn = require("@udecode/cn");
var _classVarianceAuthority = require("class-variance-authority");
var _jsxRuntime = require("react/jsx-runtime");
var Popover = exports.Popover = PopoverPrimitive.Root;
var PopoverTrigger = exports.PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverAnchor = exports.PopoverAnchor = PopoverPrimitive.Anchor;
var popoverVariants = exports.popoverVariants = (0, _classVarianceAuthority.cva)('z-[5000] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 print:hidden');
var PopoverContent = exports.PopoverContent = (0, _cn.withRef)(function (_ref, ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    className = _ref.className,
    _ref$sideOffset = _ref.sideOffset,
    sideOffset = _ref$sideOffset === void 0 ? 4 : _ref$sideOffset,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, ["align", "className", "sideOffset", "style"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PopoverPrimitive.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PopoverPrimitive.Content, _objectSpread({
      align: align,
      className: (0, _cn.cn)(popoverVariants(), className),
      ref: ref,
      sideOffset: sideOffset,
      style: _objectSpread({
        zIndex: 1000
      }, style)
    }, props))
  });
});